import { useApolloClient } from '@apollo/client';

import { Nullable } from '@clearverify/types';

import {
  InboxItemsScrollableListDocument,
  InboxItemsScrollableListQuery,
  InboxItemsScrollableListQueryVariables,
  InboxListItemInfoFragment,
  useInboxItemUnreadStatusesUpdateMutation,
} from 'src/api';

export const useInboxItemUnreadStatuses = (inboxItemId: Nullable<string>) => {
  const apolloClient = useApolloClient();

  const [inboxItemUnreadStatusesUpdateMutation, { loading }] =
    useInboxItemUnreadStatusesUpdateMutation({
      onCompleted: _data => {
        const currentCache = apolloClient.cache.readQuery<
          InboxItemsScrollableListQuery,
          InboxItemsScrollableListQueryVariables
        >({ query: InboxItemsScrollableListDocument });
        if (!currentCache) return;

        const currentList = currentCache.getInboxItemsList;
        const currentInboxItem = currentList.find(item => item.id === inboxItemId);
        if (!currentInboxItem) return;

        const updatedItem: InboxListItemInfoFragment = {
          ...currentInboxItem,
          isUnread: true,
        };

        const updatedList = currentList.map(item => (item.id === inboxItemId ? updatedItem : item));

        apolloClient.cache.writeQuery<
          InboxItemsScrollableListQuery,
          InboxItemsScrollableListQueryVariables
        >({
          query: InboxItemsScrollableListDocument,
          data: {
            ...currentCache,
            getInboxItemsList: updatedList,
          },
        });
      },
    });

  const updateInboxItemUnreadStatuses = async () => {
    if (!inboxItemId) return;
    try {
      await inboxItemUnreadStatusesUpdateMutation({
        variables: {
          input: {
            inboxItemId,
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    updateInboxItemUnreadStatuses,
    loading,
  };
};
